import type { ExternalToast } from 'vue-sonner'
import { toast } from 'vue-sonner'

type ToastMessage = string | string[]

function toFirstString(message: ToastMessage): string {
  return Array.isArray(message) ? (message[0] ?? '') : message
}

export function useAppToast() {
  return {
    success: (message: ToastMessage, options?: ExternalToast) => toast.success(toFirstString(message), options),
    error: (message: ToastMessage, options?: ExternalToast) => toast.error(toFirstString(message), options),
    warning: (message: ToastMessage, options?: ExternalToast) => toast.warning(toFirstString(message), options),
    info: (message: ToastMessage, options?: ExternalToast) => toast.info(toFirstString(message), options),
    dismiss: (id?: string | number) => toast.dismiss(id),
  }
}
